import compose from 'recompose/compose';
import { connect } from 'react-redux';

import withPermissions from '../../auth/utils/withPermissions';
import { canUserViewAppointments } from '../helpers/users';

const withCanViewAppointments = compose(
  withPermissions,
  connect((state, ownProps) => ({
    canViewAppointments: canUserViewAppointments(ownProps.permissions),
  })),
);

export default withCanViewAppointments;
